import React from 'react'
import createIcon from '@/lib/create-icon'

export const ClosedEyeSVGIcon = createIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1118_2239)">
      <path d="M6.59984 2.82663C7.05872 2.71921 7.52855 2.66552 7.99984 2.66663C12.6665 2.66663 15.3332 7.99996 15.3332 7.99996C14.9285 8.75703 14.4459 9.46978 13.8932 10.1266M9.41317 9.41329C9.23007 9.60979 9.00927 9.7674 8.76394 9.87671C8.51861 9.98602 8.25377 10.0448 7.98523 10.0495C7.71669 10.0543 7.44995 10.0049 7.20091 9.90429C6.95188 9.8037 6.72565 9.65398 6.53573 9.46406C6.34582 9.27414 6.1961 9.04792 6.09551 8.79888C5.99492 8.54985 5.94552 8.28311 5.95026 8.01457C5.955 7.74602 6.01378 7.48119 6.12309 7.23586C6.2324 6.99053 6.39001 6.76972 6.5865 6.58663M0.666504 0.666626L15.3332 15.3333M11.9598 11.96C10.8202 12.8286 9.43258 13.3099 7.99984 13.3333C3.33317 13.3333 0.666504 7.99996 0.666504 7.99996C1.49576 6.45456 2.64593 5.10436 4.03984 4.03996L11.9598 11.96Z" stroke="currentColor" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1118_2239">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>,
)
